import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, Collapse, Row } from 'antd';
import UploadedFile from 'components/SendItems/UploadedFile';
import RevertAnswerItem from 'components/RevertAnswerItem';
import ComitteeComments from 'components/ArticleOrder/ComitteeComments';
import { fileDownload } from 'fetcher';
import { downloadBlob } from 'utils';

const { Panel } = Collapse;

const handleBlobDownload = async (fileUrl, fileName) => {
  const { data } = await fileDownload(fileUrl);
  downloadBlob(data, fileName);
};

const ExpandedRow = ({ record }) => (
  <>
    <Row
      className="gx-p-3"
      gutter={[24, 32]}
    >
      {record?.authorContent?.contents?.map(
        (item) =>
          item.type !== 2 && (
            <Col
              sm={24}
              md={8}
              key={item.id}
            >
              <>{item.type === 0 ? 'Madde' : (item.type === 1 && 'Kimlik Kartı') || (item.type === 3 && 'ÜVKA')} Dosyası</>

              <UploadedFile
                content={item.media[0].name}
                fontStyle={{
                  fontSize: 14,
                }}
                extra={
                  <Button
                    type="link"
                    style={{
                      marginBottom: 0,
                    }}
                    size="large"
                    onClick={() => handleBlobDownload(item.media[0].fileFullUrl, item.media[0].name)}
                    icon={<DownloadOutlined />}
                  />
                }
              />
            </Col>
          )
      )}
    </Row>
    <Row
      className="gx-p-3"
      gutter={24}
    >
      <Col span={24}>
        {record?.authorContent?.authorDescription && (
          <Collapse>
            <Panel header="Açıklama">{record.authorContent.authorDescription}</Panel>
          </Collapse>
        )}
      </Col>
      {Array.isArray(record.revertReasons) && record.revertReasons.length > 0 && (
        <Col
          className="gx-mt-3"
          span={24}
        >
          <h2>İade Gerekçeleri</h2>
          <ul>
            {record.revertReasons.map((item, index) => (
              <RevertAnswerItem
                key={index}
                title={item.title}
                answer={item.answer}
              />
            ))}
          </ul>
        </Col>
      )}
      <Col span={24}>
        {record?.authorContent?.mediaOfferDescription && (
          <Collapse>
            <Panel header="Medya Teklifi Görüşü">{record.authorContent.mediaOfferDescription}</Panel>
          </Collapse>
        )}
      </Col>
      <Col span={24}>{record?.lastOpinion && <ComitteeComments data={record?.lastOpinion.decisions} />}</Col>
    </Row>
  </>
);

export default ExpandedRow;
